import { usePostApiAdminSyncTriggersPackages, } from '../../generated/sitComponents';
import { getAdminTriggersPackagesQueryKey, updateAdminCompanyTreeQueryData, } from './query';
export function usePostAdminSyncTriggersPackages(options) {
    return usePostApiAdminSyncTriggersPackages({
        ...options,
        onSuccess: (data, variables, onMutateResult, context) => {
            updateAdminCompanyTreeQueryData(context.client, variables.pathParams.companyTreeSettingsId, (cts) => ({
                ...cts,
                triggerPackageVersion: data.triggerPackageVersion,
            }));
            options?.onSuccess?.(data, variables, onMutateResult, context);
        },
        onSettled: async (data, error, variables, onMutateResult, context) => {
            await context.client.invalidateQueries({
                queryKey: getAdminTriggersPackagesQueryKey,
            });
            options?.onSettled?.(data, error, variables, onMutateResult, context);
        },
    });
}
//# sourceMappingURL=use-post-admin-sync-triggers-package.js.map